import type { Entity } from 'models';
import { Modal, Skeleton } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useProfileQuery } from 'features/users/queries';
import { ConsentsForm } from '../components';
import { useConsentsQuery } from '../queries';

type P = {
  entity: Entity;
  isOpened: boolean;
  onAccept: () => Promise<void> | void;
  onClose: () => Promise<void> | void;
  onReject: () => Promise<void> | void;
  requiredConsentIds: string[];
};

const ConsentsModal = ({ entity, isOpened, onAccept, onClose, onReject, requiredConsentIds }: P) => {
  const { data: profileData, isFetching: isFetchingProfile, isLoading: isLoadingProfile } = useProfileQuery();
  const {
    data: consents,
    isFetching: isFetchingConsents,
    isLoading: isLoadingConsents,
  } = useConsentsQuery({ consentIds: requiredConsentIds });

  return (
    <Modal isOpened={isOpened} maskClosable={false} onCancel={onClose} title="Confirm Consents" width="medium">
      <Modal.HugContent>
        {(isLoadingProfile && isFetchingProfile) ||
        !profileData ||
        (isLoadingConsents && isFetchingConsents) ||
        !consents ? (
          <Skeleton active paragraph={{ rows: 14 }} />
        ) : (
          <ConsentsForm
            consents={consents}
            currentAcceptedConsents={profileData.usersConsents}
            entities={[entity]}
            infoMessage="To join this community, you must agree with policies. Without consent, you cannot join the community."
            onAccept={onAccept}
            onReject={onReject}
            rejectTitle="Not now"
            showTitle={false}
          />
        )}
      </Modal.HugContent>
    </Modal>
  );
};

export default ConsentsModal;
